import state from './transaction.state.js';
import getters from './transaction.getters.js';
// import actions from './transaction.actions.js';
import mutations from './transaction.mutations.js';

export default {
  state,
  getters,
  // actions,
  mutations
};
